'use strict';

var scriptPromises = {};

/**
 * Loads an external script once and reuses the same promise for repeat requests.
 *
 * @param {string} src - Script URL to load.
 * @returns {Promise<HTMLScriptElement>} Resolves when the script is loaded.
 */
module.exports = function loadExternalScript(src) {
    if (!src) {
        return Promise.reject(new Error('Missing script source.'));
    }

    if (scriptPromises[src]) {
        return scriptPromises[src];
    }

    scriptPromises[src] = new Promise(function (resolve, reject) {
        var existingScript = document.querySelector('script[data-loader-src="' + src + '"]');

        if (existingScript) {
            if (existingScript.getAttribute('data-loaded') === 'true') {
                resolve(existingScript);
                return;
            }

            existingScript.addEventListener('load', function handleExistingLoad() {
                existingScript.setAttribute('data-loaded', 'true');
                resolve(existingScript);
            }, { once: true });
            existingScript.addEventListener('error', function handleExistingError() {
                delete scriptPromises[src];
                reject(new Error('Failed to load script: ' + src));
            }, { once: true });
            return;
        }

        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.setAttribute('data-loader-src', src);

        script.onload = function () {
            script.setAttribute('data-loaded', 'true');
            resolve(script);
        };

        script.onerror = function () {
            delete scriptPromises[src];
            reject(new Error('Failed to load script: ' + src));
        };

        document.head.appendChild(script);
    });

    return scriptPromises[src];
};
